// @file Helpers for surface permission change toast messages
import { __ } from '@@/bits/intl'

const VISITOR_MESSAGES: Record<string, string> = {
  reader: __('Visitors can now read this board.'),
  commenter: __('Visitors can now comment on this board.'),
  writer: __('Visitors can now post on this board.'),
  moderator: __('Visitors can now moderate this board.'),
  admin: __('Visitors now have admin access to this board.'),
}

const SCHOOL_MEMBER_MESSAGES: Record<string, string> = {
  reader: __('School members can now read this board.'),
  commenter: __('School members can now comment on this board.'),
  writer: __('School members can now post on this board.'),
  moderator: __('School members can now moderate this board.'),
  admin: __('School members now have admin access to this board.'),
}

const CLASSROOM_MEMBER_MESSAGES: Record<string, string> = {
  reader: __('Classroom members can now read this board.'),
  commenter: __('Classroom members can now comment on this board.'),
  writer: __('Classroom members can now post on this board.'),
  moderator: __('Classroom members can now moderate this board.'),
  admin: __('Classroom members now have admin access to this board.'),
}

const MEMBER_MESSAGES: Record<string, string> = {
  reader: __('Members can now read this board.'),
  commenter: __('Members can now comment on this board.'),
  writer: __('Members can now post on this board.'),
  moderator: __('Members can now moderate this board.'),
  admin: __('Members now have admin access to this board.'),
}

function getRoleChangeMessage(payload: { role: string; changed_group?: string; library_type?: string }): string | null {
  const { role, changed_group, library_type } = payload

  let messages = VISITOR_MESSAGES
  if (changed_group === 'member') {
    if (library_type === 'school') messages = SCHOOL_MEMBER_MESSAGES
    else if (library_type === 'classroom') messages = CLASSROOM_MEMBER_MESSAGES
    else messages = MEMBER_MESSAGES
  }

  return messages[role] ?? null
}
export { getRoleChangeMessage }
